import {EsignatureTemplate} from "platformed-client/types";
import {platformedClient} from "..";

export async function list(): Promise<EsignatureTemplate[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/esignature_templates`, {});
}
